import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_HEALTHCARE_PROVIDER } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const getAllPhysicians = createAsyncThunk(
  "healthcareProviders/get-all-physicians",
  async (data) => {
    try {
      const api = useAxios();
      const config = {
        params: {
          clientId: data.clientId,
          search: data.search,
          pageSize: data.pageSize,
          pageNumber: data.pageNumber,
          sortField: data.sortField,
          sortDirection: data.sortDirection,
        },
      };
      const response = await api.get(URL_HEALTHCARE_PROVIDER, config);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getAllPhysicians };
